import { TriadLocale } from '@triple/triad';

export const triadLocale: TriadLocale = {
  common: {
    copyright: '&copy; copyright All Right Reserved.',
  },
};
